<template>
  <div class="container course">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>在线课程</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">在线课程</h2>
        </div>
        <div class="right">
          <input @change="upload"
                 type="file"
                 name="photoImg"
                 id="getFile"
                 style="display:none;"
                 class="upload-input" />
          <label for="getFile"
                 class="fileStyle">导入文件</label>
          <el-button class="button"
                     type="primary"
                     @click="handleToCategory">分类管理</el-button>
          <el-button class="button"
                     type="primary"
                     @click="handleCourseCreate">创建课程</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="课程ID"
                      prop="id">
          <el-input v-model="query.id"
                    placeholder="输入课程ID"
                    @input="fetchCourseList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="课程名称"
                      prop="name">
          <el-input v-model="query.name"
                    placeholder="输入课程名称"
                    @input="fetchCourseList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="fetchCourseList(true)"
                          :default-time="['00:00:00', '23:59:59']"
                          clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分类"
                      prop="category_id">
          <el-select v-model="query.category_id"
                     placeholder="请选择"
                     @change="fetchCourseList(true)"
                     clearable>
            <el-option v-for="item in categorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学长搜索"
                      prop="name">
          <el-input v-model="query.author"
                    placeholder="输入学长手机号，真实姓名"
                    style="width:300px;"
                    @input="fetchCourseList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="创建人">
          <el-select v-model="query.creator"
                     placeholder="请选择"
                     @change="fetchCourseList(true)"
                     clearable>
            <el-option v-for="item in $store.state.adminList"
                       :key="item.id"
                       :label="item.nickname"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份："
                      prop="year">
          <el-date-picker v-model="year"
                          type="year"
                          placeholder="选择年"
                          @change="fetchCourseList(true)"
                          value-format="yyyy">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="search-footer">

      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">课程列表</h3>
        <el-form label-width="70px"
                 size="small"
                 style="margin-bottom:0px;"
                 label-position="top">
          <el-form-item style="">
            <el-radio-group v-model="query.status"
                            @change="fetchCourseList(true)">
              <el-radio-button v-for="(item, index) in filter.status"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="tabs">
        <el-tabs v-model="tabName"
                 @tab-click="handleTabChange">
          <el-tab-pane label="全部商品"
                       name="all"></el-tab-pane>
          <el-tab-pane label="学长商品"
                       name="senior"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="values">
        <!-- <CourseCard class="course-item" :content="item" :noUp="index == 0" :noDown="index == results.length-1" @remove="handleCourseRemove" @sort="handleSortChange" v-for="(item, index) in results" :key="item.id"/> -->
        <el-table :data="results"
                  border>
          <el-table-column prop="id"
                           width="80"
                           label="ID"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">

              {{ scope.row.id }}

            </template>
          </el-table-column>
          <el-table-column prop="id"
                           label="商品图"
                           width="120px"
                           align="center">
            <template slot-scope="scope">
              <el-image style="height: 50px"
                        :src="scope.row.picture_url"
                        fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="300"
                           label="商品名称"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="课程分类"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCategory_id(scope.row.category_id) }}
            </template>
          </el-table-column>
          <el-table-column prop="year"
                           width="80"
                           label="年份"
                           align="center"
                           show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="hours"
                           label="课时"
                           align="center">
          </el-table-column>
          <el-table-column prop="price"
                           label="售价"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.price > 0">{{
                scope.row.price + "元"
              }}</span>
              <span v-else>免费</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="market_price" label="划线价" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.market_price + "元" }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="user_count"
                           label="销量"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="goCheckOrder(scope.row)">{{ scope.row.user_count - scope.row.virtual_count }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="有效期"
                           width="170"
                           align="center">
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.start_time).format("YYYY.MM.DD") }} -
                {{ $moment(scope.row.end_time).format("YYYY.MM.DD") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="130"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否配送"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.is_deliver == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "上架" : "下架" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort"
                           label="排序值"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column label="学长"
                           width="180"
                           align="center"
                           v-if="query.is_author==1"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.author">{{ scope.row.author.realname }}/{{scope.row.author.mobile }}</span></template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="创建人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="200"
                           align="center"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="goDetail(scope.row)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToPreview(scope.row)">浏览</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToClone(scope.row.id)">克隆</el-link>
              <el-link type="danger
            "
                       @click="handleCourseRemove(scope.row.id)"
                       :underline="false">删除</el-link>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="goDetail(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="b"
                                    style="margin-bottom:6px;"><span @click="handleToPreview(scope.row)"
                          style="font-size:16px;color: #409EFF;">
                      浏览
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom:6px;"><span @click="handleToClone(scope.row.id)"
                          style="font-size:16px;color: #409EFF;">
                      复制
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom:6px;"><span @click="handleCourseRemove(scope.row.id)"
                          style="font-size:16px;color: #F56C6C;">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CourseCard from '@/components/card/Course'
import {
  courseList,
  courseDestroy,
  coursesUpdate,
  courseCategoryList,
  courseClone,
  courselistCount,
  bulkCreateLiveRoomByFile,
} from '@/api/course'

export default {
  components: {
    CourseCard,
  },
  data() {
    return {
      createDialog: false,
      query: {
        name: '',
        author: '',
        startTime: '',
        endTime: '',
        subject: '',
        category_id: '',
        status: '1',
        sort: '1',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      createDatetime: '',
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '上架', value: '1' },
          { label: '下架', value: '0' },
        ],
        sorts: [
          { label: '最新', value: '1' },
          { label: '最热', value: '2' },
        ],
      },
      categorys: [],
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      tabName: '',
      year: '',
    }
  },
  created() {
    this.parseQuery()
    this.fetchCourseList()
    this.fetchCategoryList()
    this.fetchCourseCount()
    this.$store.dispatch('getAdminList')
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
    year(value) {
      if (value) {
        this.query.year = value
      } else {
        this.query.year = ''
      }
    },
  },
  methods: {
    upload(e) {
      const file = e.target.files[0]

      if (file) {
        /******  此处为上传服务器 start   ******/
        let formData = new FormData()
        formData.append('file', file)
        // formData.append('file_exam_total_name', file.name)

        bulkCreateLiveRoomByFile(formData).then((res) => {
          console.log('res', res)
          if (res == null) {
            this.$message.success(`导入成功`)
            this.fetchCourseList()
          }
        })
      }
    },
    // 课程列表请求
    fetchCourseList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      courseList(params).then((res) => {
        this.results = res.list || []
        this.fetchCourseCount()
      })
      this.syncQuery()
    },
    // 课程列表数量请求
    fetchCourseCount() {
      const params = Object.assign({}, this.query)
      courselistCount(params).then((res) => {
        this.pageTotal = res.count[0].total
      })
    },
    // 课程分类列表请求
    fetchCategoryList() {
      courseCategoryList({ status: 1, isPaging: 0 }).then((res) => {
        let list = res.list || []
        list.unshift({ id: '', name: '全部' })
        this.categorys = list
      })
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      console.log(value, type)
      if (type === 'sort') {
        this.query.sort = value
        this.fetchCourseList()
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchCourseList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchCourseList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchCourseList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchCourseList()
      }, 20)
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/course/category`)
    },
    // 课程创建
    handleCourseCreate() {
      this.$router.push(`/course/create`)
    },
    // 排序位置变化
    handleSortChange(row, type) {
      const list = this.results
      const index = list.findIndex((v) => v.id == row.id)
      list.splice(index, 1)
      if (type == 'up') {
        list.splice(index - 1, 0, row)
      } else if (type == 'down') {
        list.splice(index + 1, 0, row)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      coursesUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('排序更新异常')
          console.log('error: ', error)
        })
    },
    // 课程删除
    handleCourseRemove(courseId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          courseDestroy({ id: courseId }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchCourseList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.category_id) {
        this.query.category_id = Number(this.query.category_id)
      }
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
      if (this.query.year) {
        this.year = this.query.year
      }
      this.tabName = this.query.is_author == 1 ? 'senior' : 'all'
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    // 表格操作跳转页面
    goDetail(item) {
      if (location.host.includes('admin.kaoyanbox.com')) {
        window.open(`https://admin.kaoyanbox.com/course/detail/${item.id}`)
      } else {
        this.$router.push(`/course/detail/${item.id}`)
        // window.open(`https://test-admin.kaoyanbox.net/course/detail/${item.id}`)
      }
    },
    // 预览
    handleToPreview(item) {
      if (item) {
        if (location.host.includes('admin.kaoyanbox.com')) {
          window.open(`https://h5.kaoyanbox.com/course/detail/${item.id}`)
        } else {
          window.open(`http://h5.kaoyanbox.net/course/detail/${item.id}`)
        }
      }
    },
    // 克隆
    handleToClone(id) {
      // 二次确认
      this.$confirm('确定要复制吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          courseClone({ id: id }).then((res) => {
            this.$message.success(`复制成功，请在下架列表中查看`)
            this.fetchCourseList()
          })
        })
        .catch(() => {})
    },
    formateCategory_id(id) {
      if (id) {
        return this.categorys.find((v) => {
          return v.id == id
        }).name
      } else {
        return '无'
      }
    },
    // 根据销量跳转到订单页面
    goCheckOrder(item) {
      this.$router.push(
        `/order/list?status=1,2,3,4&pay_type=&pageIndex=1&pageSize=10&isPaging=1&goods_name=${item.name}`
      )
    },
    setData(row) {
      console.log(row)
    },
    handleCommand(e) {
      console.log(e)
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (
            this.$store.state.adminList.findIndex((v) => {
              return v.id == val
            }) > -1
          ) {
            return this.$store.state.adminList.find((v) => {
              return v.id == val
            }).nickname
          } else {
            return '无'
          }
        } else {
          return '无'
        }
      }
    },
    handleTabChange(tab) {
      if (tab.name == 'senior') {
        this.query.is_author = 1
      } else {
        this.query.is_author = 0
      }
      this.fetchCourseList(true)
    },
  },
}
</script>

<style scoped lang="less">
.fileStyle {
  margin-right: 5px;
  border-radius: 1px;
  padding: 7px 15px;
  color: #ffff;
  background: #409eff;
}

.course {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 12px;
  }
  .tabs {
    padding: 0px 4px;
    width: 101%;
  }
  .table-header {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      width: 100%;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 30px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .course-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-link {
    margin: 0 8px;
  }
  .item-table-column {
    text-align: left;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
</style>
